// Industry detection. Resolves the active industry key from (in order):
//   1. Subdomain match               demo.app.com   → 'demo'
//   2. URL path prefix               /d/demo        → 'demo' (preview/staging)
//   3. VITE_DEFAULT_INDUSTRY env     local dev override
//   4. 'default' fallback

const subdomainMap = {
  demo: 'demo',
  fish: 'fish',
  grocery: 'grocery',
  meat: 'meat',
  restaurant: 'restaurant',
  publication: 'publication',
  pet: 'pet',
  coffee: 'coffee',
};

const pathPrefixMap = {
  '/d/demo': 'demo',
  '/f/fish': 'fish',
  '/g/grocery': 'grocery',
  '/m/meat': 'meat',
  '/r/restaurant': 'restaurant',
  '/p/publication': 'publication',
  '/x/pet': 'pet',
  '/c/coffee': 'coffee',
};

export function resolveIndustry(location = window.location) {
  const host = location.hostname ?? '';
  const subdomain = host.split('.')[0];
  if (subdomainMap[subdomain]) return subdomainMap[subdomain];

  const pathname = location.pathname ?? '';
  for (const prefix in pathPrefixMap) {
    if (pathname.startsWith(prefix)) return pathPrefixMap[prefix];
  }

  const envDefault = import.meta.env?.VITE_DEFAULT_INDUSTRY;
  if (envDefault) return envDefault;

  return 'default';
}
